import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-editor-layout',
  styleUrls: [`editor-layout.component.scss`],
  template: `
    <div class="doc-editor">
      <div class="doc-editor-content">
        <div class="toggle-sidebar" *ngIf="showToggleSidebar" (click)="toggleSidebar.emit()">
          <pt-icon *ngIf="!showSidebar" [key]='IconOpen' [size]='12'></pt-icon>
          <pt-icon *ngIf="showSidebar" [key]='IconClose' [size]='12'></pt-icon>
          <div class="rotate-90">Riepilogo</div>
        </div>

        <div class="toggle-summary" *ngIf="showToggleSummary" (click)="toggleSummary.emit()">
          <pt-icon *ngIf="!showSummary" [key]='IconOpen' [size]='12'></pt-icon>
          <pt-icon *ngIf="showSummary" [key]='IconClose' [size]='12'></pt-icon>
          <div class="rotate-90">Risultati</div>
        </div>

        <div class="doc-editor-notification-bar" [ngClass]="showNotification ? 'm-fadeIn-h' : 'm-fadeOut-h'">
          <ng-content *ngIf="showEditor" select='[notification]'></ng-content>
        </div>
        <div class="doc-editor-header" data-testid="doc-editor-header">
          <pt-editor-treatment-placeholder *ngIf="!showEditor"
                                           [enabled]="enablePlaceholder"></pt-editor-treatment-placeholder>
          <ng-content *ngIf="showEditor" select='[header]'></ng-content>
        </div>
        <div class="doc-editor-body" data-testid="doc-editor-body">
          <pt-editor-treatment-placeholder *ngIf="!showEditor"
                                           [enabled]="enablePlaceholder"></pt-editor-treatment-placeholder>
          <ng-content *ngIf="showEditor" select='[body]'></ng-content>
        </div>
      </div>
      <div class="doc-editor-sidebar" data-testid="doc-editor-sidebar" [ngClass]="showSidebar ? 'm-fadeIn-w' : 'm-fadeOut-w'">
        <pt-editor-treatment-placeholder *ngIf="!showEditor"
                                         [enabled]="enablePlaceholder"></pt-editor-treatment-placeholder>
        <ng-content *ngIf="showEditor" select='[sidebar]'></ng-content>

      </div>
      <div class="doc-editor-summary" data-testid="doc-editor-summary" [ngClass]="showSummary ? 'm-fadeIn-w' : 'm-fadeOut-w'">
        <pt-editor-treatment-placeholder *ngIf="!showEditor"
                                         [enabled]="enablePlaceholder"></pt-editor-treatment-placeholder>
        <ng-content *ngIf="showEditor" select='[summary]'></ng-content>

      </div>
    </div>
  `,
  styles: [`
    pt-editor-treatment-placeholder {
      display: contents;
    }
  `]
})
export class EditorLayoutComponent {
  @Input() showEditor = false;
  @Input() showNotification = true;

  @Input() showSidebar = true;
  @Input() showSummary = true;

  @Input() showToggleSidebar = true;
  @Input() showToggleSummary = true;

  @Output() toggleSidebar = new EventEmitter();
  @Output() toggleSummary = new EventEmitter();
  public enablePlaceholder = false;

  public IconOpen = IoniconsOutline.collapse;
  public IconClose = IoniconsOutline.expand;
}
